<template>
  <v-row class="d-flex align-center" style="max-width: 185px !important">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="primary text-body-2 font-weight-bold white--text removetexttransform"
          block
          x-large
          depressed
          v-bind="attrs"
          v-on="on"
        >
          <div class="pb-2 full-width text-center">{{ $t("Myprofile") }}</div>
          <v-icon class="pb-2 white--text sidebaricon">icons8-male-user</v-icon>
        </v-btn>
      </template>
      <v-card class="white pa-7 rounded-of">
        <v-overlay :opacity="1" :value="loading" color="white">
          <v-progress-circular indeterminate size="64" color="primary"> </v-progress-circular>
        </v-overlay>
        <!-- <pre>{{ userProfile }}</pre> -->
        <v-row class="white mb-2">
          <v-col cols="12">
            <div class="title black--text text-center">{{ dialogTitle }}</div>
          </v-col>
          <!-- <v-col cols="12" v-if="GET_currentUserProfile.level === 'superadmin'">
              <v-select v-model="useredit.level" :items=offertypes background-color="lightgrey" solo clearable
                  class="rounded-of" label="User Level" />
          </v-col> -->
          <v-col cols="12" class="d-flex justify-center">
            <v-btn
              color="subtitle-1 px-6 primary rounded-of removetexttransform"
              depressed
              @click="handleResetPasswordButton()"
            >
              Password Reset
            </v-btn>
          </v-col>
          <v-col cols="12" xs="12" md="6">
            <TextField
              label="First Name"
              background="lightgrey"
              makedense
              v-model.trim="useredit.firstName"
            />
          </v-col>
          <v-col cols="12" xs="12" md="6">
            <TextField
              label="Last Name"
              background="lightgrey"
              makedense
              v-model.trim="useredit.lastName"
            />
          </v-col>
          <v-col cols="12">
            <TextField
              disabled
              label="Email"
              background="lightgrey"
              makedense
              v-model="useredit.email"
            />
          </v-col>
          <v-col cols="6">
            <TextField
              label="Telephone"
              background="lightgrey"
              makedense
              v-model="useredit.telephone"
            />
          </v-col>
          <v-col cols="6">
            <v-checkbox v-model="useredit.isOptedIn" label="Opt-in Notification" hide-details />
          </v-col>
          <v-col cols="12">
            <TextField
              label="Postcode"
              @input="useredit.postcode = useredit.postcode.toUpperCase()"
              background="lightgrey"
              makedense
              v-model="useredit.postcode"
            />
          </v-col>
          <v-col
            cols="12"
            v-if="useredit.orgId !== '' && GET_currentUserProfile.level === 'superadmin'"
          >
            <TextField
              disabled
              label="orgId"
              background="lightgrey"
              makedense
              v-model="useredit.orgId"
            />
          </v-col>
        </v-row>
        <v-card-actions class="pa-0">
          <v-btn
            v-if="!isAdmin()"
            color="subtitle-1 px-4 primary rounded-of removetexttransform"
            depressed
            @click="isModalVisible = true"
          >
            Delete Account
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="subtitle-1 px-4 primary rounded-of removetexttransform"
            depressed
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="subtitle-1 px-4 primary rounded-of removetexttransform"
            depressed
            @click="submitEditeduser()"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isModalVisible" persistent max-width="480">
      <v-card class="pa-4">
        <h4 class="mb-4">Are you sure you want to delete your account?</h4>
        <p>Your account will be permanently deleted and cannot be recovered.</p>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="subtitle-1 px-6 primary rounded-of removetexttransform"
            depressed
            @click="isModalVisible = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="subtitle-1 px-6 primary rounded-of removetexttransform"
            depressed
            @click="deleteAccount()"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    loading: false,
    dialog: false,
    initOptInStatus: false,
    offertypes: ["superadmin", "shopadmin", "user"],
    isModalVisible: false,
    offer: { type: "" },
    useredit: {
      firstName: "",
      lastName: "",
      telephone: "",
      email: "",
      postcode: "",
      level: "",
      orgId: "",
      isOptedIn: false,
    },
  }),
  props: {
    userProfile: {
      type: Object,
      default: null,
    },
    buttonTitle: {
      type: String,
      default: "Profile",
    },
    dialogTitle: {
      type: String,
      default: "Edit Profile",
    },
  },
  computed: {
    ...mapGetters({
      GET_currentUserProfile: "GET_currentUserProfile",
    }),
    appVersion() {
      const version = require("../../../package.json").version;
      return version;
    },
  },
  components: {},
  methods: {
    isAdmin() {
      if (this.GET_currentUserProfile != null) {
        if (this.GET_currentUserProfile.level === "superadmin") {
          return true;
        }
      } else {
        return false;
      }
    },
    async grabUserprofile() {
      this.loading = true;
      let userProfileNew = await this.REDIS_read("user", this.GET_currentUserAuth.uid);
      await this.ACT_currentUserProfile(userProfileNew.data);
      this.useredit = this.userProfile;
      //Uncomment the below line after opt-in key is added to backend
      this.initOptInStatus = this.userProfile.isOptedIn;
      this.loading = false;
    },
    postcodeValidation(postcode) {
      let re = /^[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}$/i;
      return re.test(postcode);
    },
    telephoneValidation(telephone) {
      let re = /^(?:0|\+?44)(?:\d\s?){9,10}$/i;
      return re.test(telephone);
    },
    async submitEditeduser() {
      let errorCount = 0;
      let errorName = "";
      //add the space if it's a swansea postcode and is missing
      if (this.useredit.postcode.length === 6) {
        this.useredit.postcode =
          this.useredit.postcode.slice(0, 3) + " " + this.useredit.postcode.slice(3, 6);
      } else if (
        this.useredit.postcode.length === 7 &&
        this.useredit.postcode.slice(3, 4) !== " "
      ) {
        this.useredit.postcode =
          this.useredit.postcode.slice(0, 4) + " " + this.useredit.postcode.slice(4, 7);
      }
      if (this.useredit.firstName === "") {
        errorCount++;
        errorName = "Please fill in all fields";
      } else if (this.useredit.lastName === "") {
        errorCount++;
        errorName = "Please fill in all fields";
      } else if (this.useredit.email === "") {
        errorCount++;
        errorName = "Please fill in all fields";
      } else if (this.useredit.postcode === "") {
        errorCount++;
        errorName = "Please fill in all fields";
      } else if (this.useredit.level === "") {
        errorCount++;
        errorName = "Please fill in all fields";
      } else if (this.useredit.orgId === "") {
        errorCount++;
        errorName = "Please fill in all fields";
      } else if (!this.postcodeValidation(this.useredit.postcode)) {
        errorName = "Enter a valid postcode";
        errorCount++;
      } else if (
        this.useredit.telephone !== "" &&
        !this.telephoneValidation(this.useredit.telephone)
      ) {
        errorName = "Enter a valid telephone number";
        errorCount++;
      }
      if (errorCount == 0) {
        //add the space if it's a swansea postcode and is missing
        if (this.initOptInStatus !== this.useredit.isOptedIn) {
          let subject = "Swansea Bid: Notification Preference Update";
          let message = `This is to inform you that a user has updated their notification preferences to ${
            this.useredit.isOptedIn ? "opt in" : "opt out"
          }.`;
          await this.sendNotificationEmail(
            this.useredit.firstName,
            this.useredit.email,
            subject,
            message
          );
        }
        //REDIS_update(collection, entityId, data)
        this.loading = true;
        //console.log("submitting user: "+JSON.stringify(this.useredit))
        await this.REDIS_update("user", this.userProfile.entityId, this.useredit);
        //let userProfileNew = await this.REDIS_read("user",this.userProfile.entityId);
        //await this.ACT_currentUserProfile(userProfileNew.data);
        this.grabUserprofile();
        this.loading = false;
        this.dialog = false;
        this.$emit("userprofileupdated");
      } else {
        this.MIX_alertBox({ show: true, message: errorName, color: "error", timeout: "4000" });
      }
    },
    async sendNotificationEmail(firstName, email, subject, message) {
      return new Promise((resolve, reject) => {
        (async () => {
          try {
            const url = `${this.apiUrl}mail`;
            let data = {
              emailAddresses: ["Andrew@swanseabid.co.uk"],
              sendFrom: "no-reply@swansea-bid-app-demo.web.app",
              templateId: "d-916da79d2f934a1b8aefa570a4437c3f",
              subject: subject,
              userName: firstName,
              userEmail: email,
              emailBody: message,
            };
            //console.log('url', url)
            let result = await this.$axios.post(url, data);
            if (result.status === 201) {
              //this.ACT_noCloud(false);
              resolve({ success: true, data: result.data });
            } else {
              // this.ACT_noCloud(true);
              reject({ success: false, error: result.error });
            }
          } catch (error) {
            // this.ACT_noCloud(true);
            reject(error);
          }
        })();
      });
    },
    async deleteAccount() {
      let subject = "Swansea Bid: Account Deletion";
      let message = `This is to inform you that user ${this.useredit.firstName} has deleted their account.`;
      this.isModalVisible = false;
      this.dialog = false;
      await this.REDIS_delete("user", this.userProfile.entityId, this.useredit);
      await localStorage.removeItem("userToken");
      await localStorage.removeItem("vuex");
      await this.FIREBASE_logout();
      await this.sendNotificationEmail(
        this.useredit.firstName,
        this.useredit.email,
        subject,
        message
      );
      this.$router.push("/");
      location.reload();
    },
    async handleResetPasswordButton() {
      const t = this;

      // Only continue if the form has passed validation
      // if (!t.validateForm()) return

      const RESPONSE = await t.FIREBASE_resetPassword(t.userProfile.email);

      if (RESPONSE.hasErrors) {
        console.error("Error Resetting Password: ", RESPONSE.error);
      } else {
        this.dialog = false;
        this.MIX_alertBox({
          show: true,
          message: "Password Reset Email Sent!",
          color: "green",
          timeout: "4000",
        });
      }

      // t.MIX_go('/')
    },
  },
  created() {
    if (this.GET_currentUserProfile != null) {
      this.grabUserprofile();
    }
  },
};
</script>
<style scoped>
.v-input--selection-controls {
  padding: 0;
}
</style>
